export const infoCardsButtonClicked = (text, target) => ({
  type: 'InfoCards Component Clicked',
  data: {
    text,
    target,
  },
});
